import Vue from 'vue'
import VueRouter from 'vue-router'
import Apresentacao from '../views/Apresentacao.vue'

Vue.use(VueRouter)

const routes = [
	{ path: '/', name: 'Apresentacao', component: Apresentacao, },
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})
export default router
